import React from 'react';
import addBtn from '../../../assets/icons/plusBtn.svg';
import './new-property.less';

interface INewProperty {
  onClick: () => void;
  title?:string;
  dividerFillEmptySpace?: boolean;
  disabled?: boolean;
}

const NewProperty = ({
  onClick, title = 'New property', dividerFillEmptySpace, disabled,
}:INewProperty) : JSX.Element => {
  const dividerStyles = `newProperty__divider ${dividerFillEmptySpace ? 'newProperty__divider--fill-empty' : ''}`;
  return (
    <div className={`newProperty ${dividerFillEmptySpace ? 'newProperty--fill-empty' : ''}`}>
      <span className={dividerStyles} />
      <button
        disabled={disabled}
        className="newProperty__btn"
        type="button"
        onClick={onClick}
      >
        <img src={addBtn} alt="Add group-type" className="groupType-card__add-btn newProperty__plus" />
        {title}
      </button>
      <span className={dividerStyles} />
    </div>
  );
};

export default NewProperty;
